<template>
  <div class="container">
    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h2>{{ $t('settingsPage.title') }}</h2>
      </template>
    </Toolbar>

    <!-- Informations -->
    <Panel class="mb-3">
      <template #header>
        <p class="font-bold">
          {{ $t('settingsPage.eventData') }}
        </p>
      </template>
      <div class="card_details ">
        <div class="card_body">
          <div class="grid p-3 line-id-data">
            <div class="md:flex align-items-center col-12 md:text-left text-center">
              <Button
                :label="$t('settingsPage.exportEventData')"
                class="md:mt-0 mt-2 mr-2 p-button-outlined p-button-rounded w-20rem"
                @click="exportEventDataAsCSVs()"
              />
              <Button
                :label="$t('settingsPage.deleteEventData')"
                class="md:mt-0 mt-2 mr-2 p-button-outlined p-button-rounded w-20rem"
                @click="exportAndOpenDeleteDialog()"
              />
            </div>
          </div>
        </div>
      </div>
    </Panel>

    <Dialog
      v-model:visible="dialogDelete"
      :modal="true"
    >
      <template #header>
        <h3>{{ $t('settingsPage.deleteEventData') }}</h3>
      </template>

      <div class="confirmation-content">
        <span>{{ $t('settingsPage.dialog.delete.content') }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('settingsPage.dialog.delete.abortButton')"
          icon="pi pi-times"
          class="p-button-secondary p-button-rounded p-button-outlined"
          @click="dialogDelete = false"
        />
        <Button
          :label="$t('settingsPage.dialog.delete.confirmButton')"
          icon="pi pi-check"
          class="p-button-success mr-2 p-button-outlined p-button-rounded"
          @click="deleteEventData"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Panel from "primevue/panel";
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";
import Dialog from "primevue/dialog";

export default {
  name: 'SettingsForm',
  components: {Toolbar, Panel, Button, Dialog },
  data() {
    return {
      dialogDelete: false
    }
  },
  methods: {
    async exportEventDataAsCSVs() {
      try {
        await this.$settingsService.exportEventDataAsCSVs();
      } catch (e) {
        this.$emitter.emit('toast', {severity: 'error', message: 'error.global'});
      }
    },
    async exportAndOpenDeleteDialog() {
      await this.exportEventDataAsCSVs();
      this.dialogDelete = true;
    },
    async deleteEventData() {
      this.$emitter.emit("toast", {severity: 'success', message: 'settingsPage.toast.delete.in_progress'});
      this.dialogDelete = false;

      try {
        await this.$settingsService.deleteEventData();
        this.$emitter.emit("toast", {severity: 'success', message: 'settingsPage.toast.delete.success'});
      } catch (e) {
        this.$emitter.emit('toast', {severity: 'error', message: 'error.global'});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  float: right;
}

.card_details {
  span {
    float: none;
  }

  ul,
  ol {
    list-style: none;
    padding: 0;
  }

  .card_header {
    .card_times {
      background: #f7f7f7;
      padding: 10px;
      font-weight: 600;
    }
  }

  .card_body {
    li {
      width: 25vw;
      padding: 5px 0;
    }

  }
}

::v-deep(div.p-panel-header) {
  padding: 0 1rem;
}

::v-deep(div.p-panel-content) {
  padding: 0.1rem 1rem;
}
</style>
